import React from 'react';
import { useTranslation } from 'react-i18next';

import { Text } from '@/components/TextComponent';
import { Column } from '@/components/lib/components/Column';
import { ds } from '@/components/lib/design.system';

import { SearchingAvatar } from './SearchingAvatar';
import { UserAvatar } from './UserAvatar';

export const COLUMN_WIDTH = 156;

type PlayerColumnProps = {
    score: number | string;
    playerType: 'you' | 'opponent';
    username?: string;
    avatarUrl?: string;
};

export const PlayerColumn = ({ score, playerType, username, avatarUrl }: PlayerColumnProps) => {
    const { t } = useTranslation();
    return (
        <Column alignItems="center" justifyContent="center" gap="s12" width={COLUMN_WIDTH}>
            <Column alignItems="center">
                <Text variant="titleMedium2" color={ds.colorToken.text.primary} numberOfLines={1}>
                    {username ?? t(playerType)}
                </Text>
            </Column>
            <UserAvatar avatarUrl={avatarUrl} />
            <Text variant="headlineMedium" color={ds.colorToken.text.primary}>
                {score}
            </Text>
        </Column>
    );
};

export const PlayerLostColumn = ({ score, playerType, username, avatarUrl }: PlayerColumnProps) => {
    const { t } = useTranslation();
    return (
        <Column alignItems="center" width={COLUMN_WIDTH} justifyContent="center" gap="s10" opacity={0.5}>
            <Column alignItems="center">
                <Text variant="titleMedium2" color={ds.colorToken.text.primary} numberOfLines={1}>
                    {username ?? t(playerType)}
                </Text>
            </Column>
            <UserAvatar size={94} avatarUrl={avatarUrl} />
            <Text variant="headlineMedium" color="neutral300">
                {score}
            </Text>
        </Column>
    );
};

export const PlayerSearchingColumn = () => {
    return (
        <Column alignItems="center" pt="s44" width={COLUMN_WIDTH}>
            <SearchingAvatar />
        </Column>
    );
};
